import * as React from 'react';
import './Navbar.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';

import { Button } from '../FormComponents/Buttons/Button';
import Logo from '../../images/logo-flexterity.svg';
import Select from 'react-select';
import { LanguageSelectOption, useLanguagePreference } from '../../hooks/useLanguagePreference';
import { filterLanguagesForCurrentCountry } from '../../helpers/countrySubdomainHelper';

const languagePickerCustomStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#dbdcdd',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#000000',
  }),
};

const Navbar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    context: { languageOptions, userLanguagePreference },
    changeLanguageHandler,
  } = useLanguagePreference();
  const { logout, isAuthenticated } = useAuth0();

  const handleLanguageChange = (option: LanguageSelectOption | null) => {
    if (!option) {
      return;
    }
    changeLanguageHandler(option, true);
  };

  const loadHomePage = () => {
    navigate('/home');
  };

  const filteredLanguages = languageOptions && filterLanguagesForCurrentCountry(languageOptions);

  return (
    <>
      <nav className="navbar" role="navigation" aria-label="main navigation">
        {isAuthenticated && (
          <div className="navbar-language">
            {filteredLanguages && filteredLanguages.length > 1 && (
              <Select
                options={languageOptions}
                onChange={handleLanguageChange}
                value={
                  userLanguagePreference
                    ? languageOptions.find(
                        (i: LanguageSelectOption) => i.value === userLanguagePreference,
                      )
                    : null
                }
                styles={languagePickerCustomStyles}
                className={'navbar-language-item'}
              />
            )}
          </div>
        )}

        <div className="navbar-menu">
          <div className="navbar-start" onClick={loadHomePage}>
            <img src={Logo} alt="Flexterity" />
          </div>

          <div className="navbar-end">
            {isAuthenticated && userLanguagePreference && (
              <>
                <NavLink
                  to="/home"
                  className={({ isActive }) => (isActive ? 'navbar-item is-active' : 'navbar-item')}
                >
                  {t('navbar.clients')}
                </NavLink>
                <NavLink
                  to="/exerciseslist"
                  className={({ isActive }) => (isActive ? 'navbar-item is-active' : 'navbar-item')}
                >
                  {t('navbar.exercises')}
                </NavLink>
                <NavLink
                  to="/my-details"
                  className={({ isActive }) => (isActive ? 'navbar-item is-active' : 'navbar-item')}
                >
                  {t('navbar.my-details')}
                </NavLink>
                <NavLink
                  to="/help"
                  className={({ isActive }) => (isActive ? 'navbar-item is-active' : 'navbar-item')}
                >
                  {t('navbar.help')}
                </NavLink>
              </>
            )}
            {isAuthenticated && (
              <Button
                translationKey="navbar.logout"
                type="button"
                variant="outlined"
                colour="black"
                onClick={() => logout({ returnTo: window.location.origin })}
                additionalClassName="is-small"
              />
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar